import { useCallback, useState } from "react";
import {
  EMAIL_ENTITY_TYPE,
  EMAIL_TYPE,
  EMAIL_TYPE_TO_EMAIL_TEMPLATE_TYPE_MAP,
} from "@miplatform/constants";
import { useFeatureFlags } from "@miplatform/feature-flags";
import { EmailTemplateType } from "@miplatform/types";
import { EmailFormDrawer } from "@mibuildweb/components";

export const emailTypeToModal = (isMiDayFeatureEnabled) => (type) => {
  if (isMiDayFeatureEnabled && type === EMAIL_TYPE.DISPATCH) {
    return [EmailTemplateType.TechnicianEnRouteNotice];
  }
  return EMAIL_TYPE_TO_EMAIL_TEMPLATE_TYPE_MAP[type];
};

export const useDispatchEmailDrawer = ({ onOpen = () => null } = {}) => {
  const [emailDrawersMap, setEmailDrawersMap] = useState({});

  const { featureFlags } = useFeatureFlags();
  const isMiDayFeatureEnabled = featureFlags?.miDayEnabled;

  const handleEmailDrawerOpen = useCallback(
    ({ attempt, type }) => {
      onOpen();

      setEmailDrawersMap((previous) => ({
        ...previous,
        ...emailTypeToModal(isMiDayFeatureEnabled)(type).reduce(
          (drawers, templateType) => ({
            ...drawers,
            [templateType]: {
              attempt,
              templateType,
              isOpen: true,
            },
          }),
          {}
        ),
      }));
    },
    [isMiDayFeatureEnabled, onOpen]
  );

  const handleEmailDrawerClose = useCallback((templateType) => {
    setEmailDrawersMap((previous) => ({
      ...previous,
      [templateType]: { ...previous[templateType], isOpen: false },
    }));

    setTimeout(
      () =>
        setEmailDrawersMap((previous) => {
          const drawers = { ...previous };
          delete drawers[templateType];
          return drawers;
        }),
      300
    );
  }, []);

  const clearEmailDrawers = useCallback(() => setEmailDrawersMap({}), []);

  return {
    emailDrawersMap,
    handleEmailDrawerOpen,
    handleEmailDrawerClose,
    clearEmailDrawers,
  };
};

export const DispatchEmailDrawer = ({
  emailDrawersMap,
  onCloseoutDrawerOpen,
  onEmailDrawerClose,
}) =>
  Object.values(emailDrawersMap).map(({ attempt, isOpen, templateType }) => (
    <EmailFormDrawer
      key={`${attempt.id}-${templateType}`}
      open={isOpen}
      entity={attempt}
      entityType={EMAIL_ENTITY_TYPE.ATTEMPT}
      templateType={templateType}
      onCloseoutDrawerOpen={onCloseoutDrawerOpen}
      onClose={onEmailDrawerClose}
    />
  ));
